;(function(EG, undefined) {
  'use strict';

  var EMAIL_REGEX,
    ALPHABETS,
    ACTION_TO_STATUS_MAPPING,
    STATUS_TO_ACTIONS_MAPPING,
    CHARACTER_LIMIT,
    SCROLL_OFFSET,
    AUTHENTICATION_MODES,
    REGIONAL_NAMES,
    ROLE_SPECIFIC_TABS,
    tabsLoaded,
    GENDER_MALE_CONSTANT,
    GENDER_UNSPECIFIED_CONSTANT,
    GENDER_UNDISCLOSED_CONSTANT,
    GENDER_FEMALE_CONSTANT,
    genderMap,
    DEFAULT_VALUE;

  EMAIL_REGEX = new RegExp('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]');
  ALPHABETS = 'abcdefghijklmnopqrstuvwxyz'.split('');
  CHARACTER_LIMIT = 2;
  DEFAULT_VALUE= "0";
  AUTHENTICATION_MODES = [
    {
      code: 'SSO',
      label: 'SSO'
    },
    {
      code: 'LOGIN',
      label: 'LOGIN'
    }
  ];

  SCROLL_OFFSET = 1;

  GENDER_MALE_CONSTANT = "Male";
  GENDER_UNSPECIFIED_CONSTANT= "Unspecified";
  GENDER_UNDISCLOSED_CONSTANT= "Undisclosed";
  GENDER_FEMALE_CONSTANT= "Female";
  genderMap = new Map();
  genderMap.set(GENDER_MALE_CONSTANT,uitk.i18n.msg('profile_title_male'));
  genderMap.set(GENDER_UNSPECIFIED_CONSTANT,uitk.i18n.msg('profile_gender_unspecified'));
  genderMap.set(GENDER_UNDISCLOSED_CONSTANT,uitk.i18n.msg('profile_gender_undisclosed'));
  genderMap.set(GENDER_FEMALE_CONSTANT,uitk.i18n.msg('profile_title_female'));


  ACTION_TO_STATUS_MAPPING = {
    enable: {
      to_status_code: EG.Users.Profile.Constants.USER_STATUS.active.value
    },
    disable: {
      to_status_code: EG.Users.Profile.Constants.USER_STATUS.inactive.value
    },
    approve: {
      to_status_code: EG.Users.Profile.Constants.USER_STATUS.active.value
    },
    reject: {
      to_status_code: EG.Users.Profile.Constants.USER_STATUS.deleted.value
    },
    delete: {
      to_status_code: EG.Users.Profile.Constants.USER_STATUS.deleted.value
    }
  };

  STATUS_TO_ACTIONS_MAPPING = {
    '1': [
      {
        action: EG.Users.Constants.DISABLE,
        label: uitk.i18n.msg('user_status_action_disable')
      },
      {
        action: EG.Users.Constants.DELETE,
        label: uitk.i18n.msg('user_status_action_delete')
      }
    ],
    '2': [
      {
        action: EG.Users.Constants.ENABLE,
        label: uitk.i18n.msg('user_status_action_enable')
      },
      {
        action: EG.Users.Constants.DELETE,
        label: uitk.i18n.msg('user_status_action_delete')
      }
    ],
    '3': [],
    '4': [
      {
        action: EG.Users.Constants.APPROVE,
        label: uitk.i18n.msg('user_status_action_approve')
      },
      {
        action: EG.Users.Constants.REJECT,
        label: uitk.i18n.msg('user_status_action_reject')
      }
    ]
  };


  REGIONAL_NAMES = {
    '60086': {
      label: uitk.i18n.msg('profile_chinese_name')
    },
    '60095': {
      label: uitk.i18n.msg('profile_secondary_name')
    }
  };

  ROLE_SPECIFIC_TABS = [
    EG.Users.Profile.TemplatingConfig.Names.costCenters,
    EG.Users.Profile.TemplatingConfig.Names.userAssociations,
    EG.Users.Profile.TemplatingConfig.Names.arrangeAndApprove
  ];

  tabsLoaded = [];

  function getActionToStatus(action) {
    return ACTION_TO_STATUS_MAPPING[action];
  }

  function getStatusToActions(statusCode) {
    return STATUS_TO_ACTIONS_MAPPING[statusCode];
  }

  function getResponseJSON(response) {
    var responseJson;
    responseJson = response.responseJSON;
    if (!responseJson && response.responseText) {
      try {
        responseJson = JSON.parse(response.responseText);
      } catch (e) {
        EG.Users.OmnitureUtil.omnitureTrackSomethingWentWrong();
        responseJson = {
          error: 'EGE_USERS_ERR_DEFAULT'
        };
      }
    }
    return responseJson;
  }

  /**
   * Parses the searchQuery to ['firstname', 'middlename', 'lastname', 'emails']
   * @param  {String} query 'Son Goku goku@sayiajins.com vegeta@saiyajin'
   * @return {Object}
   *          {
   *            firstname: 'Son',
   *            middlename: '',
   *            lastname: 'Goku',
   *            emails: [ 'goku@sayiajins.com', 'vegeta@saiyajin' ]
   *          }
   */
  function parseSearchQuery(query) {
    var queries = query.split(' '),
      searchQuery = {
        firstname: '',
        middlename: '',
        lastname: '',
        emails: []
      };

    if (queries.length < 1) {
      return {};
    }

    searchQuery.emails = getEmailsFromCollection(queries);
    queries = _.difference(queries, searchQuery.emails);

    searchQuery = _.extend({}, searchQuery, getNamesFromCollection(queries));

    return searchQuery;
  }

  /**
   * Filters out all email enteries from the collection
   * @param  {Array} collection ['Goku', 'goku@sayiajins.com', 'vegeta@saiyajins']
   * @return {Array} ['goku@sayiajins.com', 'vegeta@saiyajins']
   */
  function getEmailsFromCollection(collection) {
    var emails = _.filter(collection, function(value) {
      return EMAIL_REGEX.test(value);
    });
    return emails;
  }

  /**
   * Filters the First,Middle,Last name from the query
   * @param  {Array} collection ['name1', 'name2']
   * @return {Object}
   *         'Goku' => {firstname: 'Goku'}
   *         'Goku San' => {firstname: 'Goku', lastname: 'San'}
   *         'Son Goku San' => {firstname: 'Son', middlename: 'Goku' lastname: 'San'}
   */
  function getNamesFromCollection(collection) {
    var availableNames = ['firstname', 'middlename', 'lastname'],
      query;

    if (collection.length < 1) {
      return {};
    }

    query = _.object(availableNames, collection);

    if (!query.lastname && query.middlename) {
      query.lastname = query.middlename;
      query.middlename = undefined;
    }

    return query;
  }

  function isFCBEnabledForActionActivation() {
    return EG.Users.Constants.action_activation_enabled === true;
  }

  function getPhoneType(typeCode) {
    var phoneType = EG.Users.Constants.phone_types.code_to_label_map,
      phoneTypeLabel = phoneType[typeCode] ? phoneType[typeCode] : '';
    return phoneTypeLabel;
  }

  function getPhoneTypeCode(type) {
    var phoneType = EG.Users.Constants.phone_types.label_to_code_map,
      phoneTypeCode = phoneType[type] ? phoneType[type] : '';
    return phoneTypeCode;
  }

  function getNAPhoneAreacodeNumber(num) {
    return {
      areaCode: num.substr(0, 3),
      number: num.substr(3, 10)
    };
  }

  function getCompanyId() {
    // For NA when admin logs in and takes control for a company, companyId is to be fetched from global context
    //Order must be globalContext first and then User.CompanyId
    if(!_.isUndefined(EG.Users.RequestedUser)) {
      return EG.Users.RequestedUser.isCrossGpid === true ? EG.Users.RequestedUser.companyId : (EG.globalContext.get('managedCompanyId') || EG.user.companyId);
    }

      return (EG.globalContext.get('managedCompanyId') || EG.user.companyId);

  }

  function isNAProductId(productId) {
    return productId == 60000 || productId == 60004;
  }

  function getProfileRegion(productId) {
    if(productId == 60000 || productId == 60004) {
      return "NA";
    }
    return "EU";
  }

  function isProfileRegionSame(productId1, productId2) {
    return isNAProductId(productId1) == isNAProductId(productId2);
  }

  function checkIfSameRegion(productId1, region) {
    return getProfileRegion(productId1) == region;
  }

  function getManagedCompanyIds() {
    if (isMultiGpidTMSearchEnabled()) {
      const companyIds = [];
      for (const [key, value] of Object.entries(EG.Users.Constants.TMSearchData)) {
        if (value["isSearchAllowed"]) {
          companyIds.push(key)
        }
      }
      return companyIds;
    } else {
      // default behaviour
      return getCompanyId();
    }
  }

  function getMultiGpidQueryParams() {
    let queryParams;
    if(isMultiGpidTMSearchEnabled()) {
      queryParams = 'na_company_ids='
          + EG.Users.Utils.getManagedCompanyIdsForRegion("NA")+'&eu_company_ids='+EG.Users.Utils.getManagedCompanyIdsForRegion("EU");
    }else {
        queryParams = EG.isNA?'na_company_ids=':'eu_company_ids=';
        queryParams += getCompanyId();
    }
    return queryParams;
  }

  function getManagedCompanyIdsForRegion(region) {
    if (isMultiGpidTMSearchEnabled()) {
      const companyIds = [];
      for (const [key, value] of Object.entries(EG.Users.Constants.TMSearchData)) {
        if (value["isSearchAllowed"] && checkIfSameRegion(value["productId"], region)) {
          companyIds.push(key)
        }
      }
      return companyIds;
    } else {
      // default behaviour
      return getCompanyId();
    }
  }

  function getCompanyIdsForGivenRegion(companyIds, region) {
    if (companyIds !== undefined && companyIds.length != 0) {
      if(region) {
        return companyIds.filter(id => getCompanyRegion(id) === region);
      }
      else {
        return companyIds;
      }

    }
  }

  function getSearchCompanyIds(region) {
    const selectedCompanyIds = getSelectedCompanyIdsFromCompaniesFilter();
    if (selectedCompanyIds !== undefined && selectedCompanyIds.length != 0) {
      return getCompanyIdsForGivenRegion(selectedCompanyIds, region);
    }else if(region){
      return getManagedCompanyIdsForRegion(region);
    } else {
      return getManagedCompanyIds();
    }
  }

  function getCompanyRegion(companyId) {
    const tmSearchData = EG.Users.Constants.TMSearchData;
    if(tmSearchData &&  tmSearchData[companyId]) {
      return tmSearchData[companyId]['geoHeader'];
    }
  }

  function getUserIdForGivenCompany(companyId) {
    const tmSearchData = EG.Users.Constants.TMSearchData;
    if(tmSearchData &&  tmSearchData[companyId]) {
      return tmSearchData[companyId]['userId'];
    }
  }

  function getCompanyName(companyId) {
    const companiesInfoMap = EG.Users.Constants.TMSearchData;
    if(companiesInfoMap && companiesInfoMap[companyId]) {
      return companiesInfoMap[companyId]['companyName'];
    }
  }


  function isMultiGpidTMSearchEnabled() {
    return EG.Users.Constants.multi_gpid_tm_search_enabled === true && !EG.Users.legacyGuestMigration;
  }

  function getSelectedCompanyIdsFromCompaniesFilter() {
    return EG.Users.Search.Filters.companyNames.getSelected();
  }

  /**
   * AutoComplete is utility for all the default functionalities to AutoComplete Component
   * @param  {Array} collection Complete result set
   * @param  {String} query
   * @param  {Function} queryParser Function that parses the matched result set
   * @return {Object}
   *         {
   *           'query': String,
   *           'search_results': Array
   *         }
   */
  function autoComplete(collection, query, filterBy, queryParser) {
    var results = [],
      data = [],
      parser = null;

    if (query == 'zzzzzz') {
      return;
    }

    data = _.clone(collection.toJSON());
    parser = function(result) {
      return {
        display_value: result.name,
        opt_display_value: result.optName,
        value: result.value,
        category: result.category,
        id: result.id
      };
    };

    queryParser = queryParser || parser;

    results = data.filter(function(model) {
      var isQueryExists = model[filterBy].toLowerCase().indexOf(decodeURIComponent(query.toLowerCase()));
      return isQueryExists !== -1;
    });

    results = results.map(queryParser);

    return {
      query: query,
      search_results: results
    };
  }

  function getI18MonthNames(locale) {
    return moment.monthsShort() || [];
  }

  function deepCloneObject(obj) {
    var newObj = {};
    _.each(obj, function(value, key, selfObj) {
      if (_.isArray(value)) {
        newObj[key] = value;
      } else if (_.isObject(value)) {
        newObj[key] = deepCloneObject(value);
      } else {
        newObj[key] = value;
      }
    });
    return newObj;
  }

  function recurse(fn) {
    var value,
      params = [],
      canRecurse = false;

    return function recursion() {
      params.push(arguments);

      if (!canRecurse) {
        canRecurse = true;

        while (params.length) {
          value = fn.apply(this, params.shift());
        }

        canRecurse = false;

        return value;
      }
    };
  }

  function parseJson(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return false;
    }
  }

  function getUserStatus(statusCode) {
    var status;
    switch (statusCode) {
      case EG.Users.Profile.Constants.USER_STATUS.active.value:
        status = EG.Users.Profile.Constants.USER_STATUS.active.label;
        break;
      case EG.Users.Profile.Constants.USER_STATUS.inactive.value:
        status = EG.Users.Profile.Constants.USER_STATUS.inactive.label;
        break;
      case EG.Users.Profile.Constants.USER_STATUS.deleted.value:
        status = EG.Users.Profile.Constants.USER_STATUS.deleted.label;
        break;
      case EG.Users.Profile.Constants.USER_STATUS.pending.value:
        status = EG.Users.Profile.Constants.USER_STATUS.pending.label;
        break;
    }
    return status;
  }

  //get pos country iso2 code from tpid config object
  function getPOSCountryIso2() {
    var countryIso2;
    if (EG.Users.Constants.tpid_config) {
      countryIso2 = EG.Users.Constants.tpid_config.countryIso2
        ? EG.Users.Constants.tpid_config.countryIso2.toLowerCase()
        : '';
    }
    return countryIso2;
  }

  //get pos country iso3 code from tpid config object
  function getPOSCountryIso3() {
    var countryIso3;
    if (EG.Users.Constants.tpid_config) {
      countryIso3 = EG.Users.Constants.tpid_config.countryIso3
        ? EG.Users.Constants.tpid_config.countryIso3.toUpperCase()
        : '';
    }
    return countryIso3;
  }

  function getSelectedUserProfileId() {
    return fetchUserIdFromGlobalcontext() || EG.user.userId;
  }

  function updateUserIdInGlobalContext(userId) {
    var arrangee;
    if (_.isString(userId)) {
      userId = parseInt(userId);
    }
    arrangee = {
      userId: userId
    };
    if (EG.globalContext.arrangees) {
      //This is required before EG.globalContext.set() as it updates legacy_globalcontext with
      // EG.globalContext.arrangees data.
      EG.globalContext.arrangees.reset(arrangee);
      EG.globalContext.set({
        arrangees: [arrangee]
      });
    }
  }

  function fetchUserIdFromGlobalcontext() {
    var arrangees = EG.globalContext.get('arrangees');
    return arrangees && arrangees.length > 0 ? arrangees[0].userId : undefined;
  }

  function isMultiTravller() {
    var arrangees;
    arrangees = EG.globalContext.get('arrangees');
    if(arrangees && arrangees.length == 1){
      return !(arrangees[0].userId === EG.user.userId);
    }
    return arrangees && arrangees.length > 1;
  }
  var userModal = (function() {
    function _isModalWithId(modal, id) {
      return modal && modal.options && modal.options.modalId === id;
    }
    return {
      subscribe: function(eventType, callback, id) {
        var onModalAction = function(type, modal) {
          if (_isModalWithId(modal, id)) {
            callback(modal, type);
          }
        };
        uitk.unsubscribe(eventType);
        uitk.subscribe(eventType, onModalAction);
      }
    };
  })();

  function applyFilterValidation(filterInput, checkValidity, filter) {
    $('body').on('keyup', filterInput, function() {
      var selectedFilter = $(filterInput);

      if (selectedFilter.val().trim().length < CHARACTER_LIMIT) {
        selectedFilter.removeClass('invalid').addClass('valid');

        filter.setFilterValidity(true);
      }
      if (_.isFunction(checkValidity)) {
        checkValidity();
      }
    });
  }

  function applySearchValidation(filterInput, checkValidity, results, filter) {
    var selectedFilter = $(filterInput);

    if (results && results.search_results && results.search_results.length < 1) {
      selectedFilter.addClass('invalid');

      filter.setFilterValidity(false);
    } else {
      selectedFilter.addClass('valid');

      filter.setFilterValidity(true);
    }
    if (_.isFunction(checkValidity)) {
      checkValidity();
    }
  }

  function parseDefaultFormAttributes(formElem) {
    if (formElem.value === '') {
      return undefined;
    }

    return formElem.value;
  }

  function isTravelConsultant() {
    if (EG.agent && EG.agent.agentCode) {
      return true;
    }
    return false;
  }

  function canManageBDM() {
    return EG.scopes && (EG.scopes.indexOf('bdm.manage.all') != -1 || EG.scopes.indexOf('bdm.manage.company') != -1);
  }

  function hasManageUserRights() {
    if (
      EG.scopes &&
      EG.scopes.indexOf('user.manage.profile') != -1
    ) {
      return true;
    }
    return false;
  }

  function hasManageOrgManagerRights() {
    if (
        EG.scopes &&
        EG.scopes.indexOf('user.manage.orgmanagerprofile') != -1
    ) {
      return true;
    }
    return false;
  }

  function hasCommunityTabRights() {
    if (
        EG.scopes &&
        EG.scopes.indexOf('all.access.communities') != -1
    ) {
      return true;
    }
    return false;
  }

  function hasCreateUserRights() {
	  return EG.scopes && EG.scopes.indexOf('user.create.profile') != -1;
  }

  function hasManageApprovalSettingRights() {
    return EG.scopes && EG.scopes.indexOf('approval.manage.settings') != -1;
  }

  function hasManageTmWizardRights() {
	  return EG.scopes && EG.scopes.indexOf('company.manage.tmwizard') != -1;
  }

  function hasManageGuestRights() {
    return EG.scopes
        && EG.scopes.indexOf(EG.Users.Profile.Globals.globalGuestManagerScope) != -1;
  }

  function allowGuestManager() {
    return hasManageGuestRights()
        && EG.Users.Constants.global_guest_manager_enabled;
  }

  function hasManageGuestOnly() {
    return !hasManageUserRights() && hasManageGuestRights()
  }

  function isGGMViewingSelf(vieweeId) {
    return hasManageGuestOnly() && isProfileViewedBySelf(vieweeId)
  }

  function canViewTravelerPicker() {
    if (isScopesExist() && EG.scopes.indexOf(EG.Users.Profile.Globals.travelerPickerScope) != -1) {
      return true;
    }
    return false;
  }

  function isGlobalArranger() {
    if (isScopesExist() && EG.scopes.indexOf('user.manage.globalarrangees') != -1) {
      return true;
    }
    return false;
  }

  function canViewArrangeePicker() {
    return (isScopesExist() && EG.scopes.indexOf(EG.Users.Profile.Globals.arrangeePickerScope) != -1) || canManageGuest;
  }

  function canManageGuest() {
    return isScopesExist() && EG.scopes.indexOf(EG.Users.Profile.Globals.globalGuestManagerScope) != -1;
  }
  
  function canArrange() {
    if (isScopesExist() && EG.scopes.indexOf(EG.Users.Profile.Globals.arrangerScope) != -1) {
      return true;
    }
    return false;
  }

  function isScopesExist() {
    if (EG.scopes) {
      return true;
    }
    return false;
  }

  function canAssignClosedTravelerGroup() {
    if (isScopesExist() && EG.scopes.indexOf('user.update.closedtravelergroup') != -1) {
      return true;
    }

    return false;
  }

  function canCreateNewUser() {
    if (
      isScopesExist() &&
      EG.scopes.indexOf('user.create.profile') != -1 &&
      isNotAdminWithoutCompanyContext()
    ) {
      return true;
    }
    return false;
  }

  function canCreateGuestUser() {
    return canCreateNewUser() || isScopesExist() &&
        EG.scopes.indexOf(EG.Users.Profile.Globals.userCreateGuestScope) != -1 &&
        isNotAdminWithoutCompanyContext();
  }

  function canEditLockedCDF() {
    if (isScopesExist() && EG.scopes.indexOf('user.modify.customdatafields') != -1) {
      return true;
    }
    return false;
  }

  function canUpdateUserStatus() {
    if (isScopesExist() && EG.scopes.indexOf('user.update.status') != -1) {
      return true;
    }
    return false;
  }

  function canUpdateGuestStatus() {
    return isScopesExist() && EG.scopes.indexOf('user.update.gueststatus') != -1;
  }

  function canUpdateStatus(userType) {
    return EG.Users.Utils.canUpdateUserStatus() ||
        EG.Users.Utils.canUpdateGuestStatus() && EG.Users.Utils.isGGMViewingGGU(userType);
  }

  function canDeleteProfileWithPastTrips() {
    if (isScopesExist() && EG.scopes.indexOf('user.delete.profilewithpasttrip') != -1) {
      return true;
    }
    return false;
  }

  function isGGMViewingGGU(userType) {
    return hasManageGuestRights()
        && isGlobalGuestUserType(userType);
  }

  function canEditReservationEmailsForAllTrips(managedUserScopes){
    return (!_.isEmpty(managedUserScopes) && (managedUserScopes.indexOf('user.edit.reservationsettings') != -1));
  }

  function isNotAdminWithoutCompanyContext() {
    var companyId = EG.Users.Utils.getCompanyId();
    return companyId != null && companyId != 0;
  }

  function transformCollectionToAutocompleteCompatible(companyUsers) {
    var autocompleteCompatibleResult = [];
    _.each(companyUsers, function(user) {
      autocompleteCompatibleResult.push({
        display_value: user.first_name + ' ' + user.last_name,
        id: user.user_id,
        opt_display_value: user.email,
        value: user.first_name + ' ' + user.last_name + ' (' + user.email + ')',
        is_occasional: user.is_guest
      });
    });
    return autocompleteCompatibleResult;
  }

  function getOffset(element) {
    var elementBoundingRect, bodyRect, position;
    elementBoundingRect = element.getBoundingClientRect();
    bodyRect = document.body.getBoundingClientRect();
    position = {
      top: elementBoundingRect.top - bodyRect.top,
      bottom: elementBoundingRect.bottom - bodyRect.bottom,
      left: elementBoundingRect.left - bodyRect.left,
      right: elementBoundingRect.right - bodyRect.right
    };
    return position;
  }

  function scrollTop(el) {
    if(_.isUndefined(el) || _.isUndefined(el.getBoundingClientRect)) { return; }
    var scrollTop = getOffset(el).top;
    scrollTo(scrollTop, 500, false);
  }

  function scrollDown(el) {
    scrollTo(getOffset(el).top, 500, true);
  }

  function scrollTo(destination, duration, isScrollDown) {
    var start = window.pageYOffset;
    var startTime = moment(),
      reqAnimationFrameId;

    var documentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );
    var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body[0].clientHeight;
    var destinationOffsetToScroll = Math.round(
      documentHeight - destination < windowHeight ? documentHeight - windowHeight : destination
    );

    function cancelAnimationIfExist() {
      if (reqAnimationFrameId) {
        cancelAnimationFrame(reqAnimationFrameId);
      }
    }

    function scroll() {
      var now = moment();
      var ratio = Math.min(1, (now - startTime) / duration);
      window.scroll(0, Math.ceil(ratio * (destinationOffsetToScroll - start) + start));

      if(isScrollDown) {
        if(window.pageYOffset >= destinationOffsetToScroll) {
          cancelAnimationIfExist();
          return;
        }
      } else {
        if(window.pageYOffset <= destinationOffsetToScroll) {
          cancelAnimationIfExist();
          return;
        }
      }

      reqAnimationFrameId = requestAnimationFrame(scroll);
    }

    scroll();
  }

  function getPhonePrefix(number, countryCode) {
    var prefix = '';
    if (_.isNull(number) || _.isUndefined(number)) {
      return prefix;
    }

    if (!_.isEmpty(countryCode) && number.charAt(0) != '+') {
      prefix = '+';
    }
    return prefix;
  }

  function setDesktopView() {
    $('body')
      .removeClass('mobile')
      .addClass('desktop');
  }

  function setMobileView() {
    $('body')
      .removeClass('desktop')
      .addClass('mobile');
  }

  function isMobileView() {
    var screenWidth = $(window).width();
    return screenWidth <= EG.Users.Constants.MAX_MOBILE_VIEW_SCREEN_SIZE;
  }

  function getUrlParam(name) {
    if ((name = new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)').exec(location.search))) {
      return decodeURIComponent(name[1]);
    }
  }

  function redirectToErrorPage() {
    EG.Users.Router.navigate('error', {
      trigger: true
    });
  }

  function replaceSpaceWithUnderscore(input) {
    return input.replace(/ /g, '_').toLowerCase();
  }

  /**
   *
   * @param {String|Number} vieweeUserId
   * @returns {Boolean}
   *
   * Returns the result of passed ID matches with logged in user id.
   */
  function isProfileViewedBySelf(vieweeUserId) {
    return vieweeUserId == EG.user.userId;
  }


  function getGenderByCode(genderCode) {
    var genders, gender;

    genders = EG.Users.Constants.genders;

    gender = _.findWhere(genders, {
      value: genderCode
    });

    if (_.isNull(gender) || _.isUndefined(gender)) {
      return {
        name: ''
      };
    }

    return gender;
  }

  function getAbsoluteUrl() {
    return window.location.origin + window.location.pathname;
  }

  function getMaxCostCentreToView(costCentreType) {
    if (costCentreType == EG.Users.Constants.costCenters.CC1) {
      return EG.Users.Constants.max_cost_centre_to_view_cc1 || 100;
    }

    if (costCentreType == EG.Users.Constants.costCenters.CC2) {
      return EG.Users.Constants.max_cost_centre_to_view_cc2 || 100;
    }

    if (costCentreType == EG.Users.Constants.costCenters.CC4 || costCentreType == EG.Users.Constants.costCenters.CC5) {
      return EG.Users.Constants.max_cost_centre_to_view_cc4_5 || 100;
    }
  }

  function getCardExpiryStatus(expiryDate, daysToExpire) {
    var _data = {
        isExpiring: false,
        isExpired: false
      },
      endDate,
      today,
      daysDifference;
    today = moment();
    if (expiryDate && daysToExpire) {
      endDate = moment(expiryDate, 'YYYY.MM.DD');
      daysDifference = endDate.diff(today, 'days');
      if (daysDifference <= daysToExpire && daysDifference >= 0) {
        _data.isExpiring = true;
      }
      if (daysDifference < 0) {
        _data.isExpired = true;
      }
    }
    return _data;
  }

  function reloadPage(url) {
    window.location.assign(url);
    window.location.reload(true);
  }

  function isAdminLogin() {
    return EG.isNA && EG.user.companyId == 0;
  }

  function analyzeSave() {
    var analyzeOptions;

    analyzeOptions = {
      linkId: EG.Users.Profile.Analytics.SAVED,
      linkObj: null
    };
    uitk.analytics.track('a', analyzeOptions);
  }

  function showLoadingScreen(id) {
    uitk.publish('interstitial.changed', {
      contentId: id ? id : EG.Users.Profile.Globals.InterstitialContainerId
    });
  }

  function hideLoadingScreen(id) {
    uitk.publish('interstitial.complete', {
      contentId: id ? id : EG.Users.Profile.Globals.InterstitialContainerId
    });
  }

  function getErrorDescription(error) {
    var errorDescription;
    error = error ? error.toLowerCase() : 'EGE_USERS_ERR_DEFAULT';
    errorDescription = EG.Users.Profile.Error.Descriptions[error] || 'EGE_USERS_ERR_DEFAULT';

    if(errorDescription === 'EGE_USERS_ERR_DEFAULT') {
       uitk.analytics.track('error', {errorkey:'USERS_SOMETHING_WENT_WRONG'});
    }
    return uitk.i18n.msg(errorDescription);
  }

  function getErrorListContent(errorList) {
    var msg;

    msg = '';
    if (errorList.length) {
      msg += '<ul>';
      _.each(errorList, function(err) {
        msg += '<li>' + err.component + '</li>';
      });
      msg += '</ul>';
    }
    return msg;
  }

  function isGuestUser(userType) {
    return userType && userType.toLowerCase() === EG.Users.Profile.Globals.guestUser;
  }

  function isLoggedInUserGlobalGuest() {
    var userInfo = EG.Users.Profile.Data.userInfo;
    return !_.isUndefined(userInfo) && isGlobalGuestUserType(userInfo.type) && isLoggedInUser(userInfo.user_id);
  }

  function isGlobalGuestUserType(userType) {
    return ((_.isString(userType) && userType.toLowerCase() === EG.Users.Profile.Globals.globalGuest) || (_.isNumber(userType) && userType === EG.Users.Constants.USER_TYPE.globalGuest))
  }

  function transformNumericToAlphabet(number) {
    var prefixCount, postFix, alphabetsLength, alphabet, charIdx;

    alphabetsLength = ALPHABETS.length;
    charIdx = number >= alphabetsLength ? 0 : number;
    prefixCount = Math.round(Math.floor(number / alphabetsLength));
    postFix = number % alphabetsLength;
    alphabet = ALPHABETS[charIdx];

    if (number > alphabetsLength) {
      alphabet = ALPHABETS[postFix];
    }

    alphabet = alphabet.toUpperCase();

    if (prefixCount < 1) {
      return alphabet;
    }

    for (var i = 0; i < prefixCount; i++) {
      alphabet += ALPHABETS[postFix];
    }

    return alphabet.toUpperCase();
  }

  function removeLoader($container) {
    $container.find('.loader').remove();
  }

  function isUserGuest(user) {
    return user.is_guest || user.is_occasional || user.is_guest_traveler;
  }

  function formatToLocalizedNumber(number) {
    return uitk.i18n.number(number, {
      locale: EG.currentLocale
    });
  }

  function getParameterByName(name, url) {
    var regex, results;

    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');

    regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    results = regex.exec(url);

    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  //TODO:change role type string once flexible arranger role type is changed by UITK
  function isFlexibleArranger() {
    if (
      EG.user &&
      (EG.user.roleType == 'Global Arranger' || EG.user.roleType == 'Flexible Arranger')
    ) {
      return true;
    }
    return false;
  }

  function isLoggedInUser(userId) {
    return userId == EG.user.userId;
  }

  function isEsiUser() {
     return EG.Users.Constants['activeProfile'] && EG.Users.Constants['primaryProfile'];
  }

  function isLoggedInUserESIPrimary() {
      return EG.Users.Constants['activeProfile'] == EG.Users.Constants['primaryProfile'];
  }
  function getAuthenticationModes(defaultAuthenticationMode) {
    var authentication_modes, defaultMode;

    authentication_modes = _.map(AUTHENTICATION_MODES, function(mode) {
      mode.selected = false;
      return mode;
    });

    defaultMode = _.findWhere(authentication_modes, {
      code: defaultAuthenticationMode
    });

    if (_.isEmpty(defaultMode)) {
      // Defaulted to LOGIN
      defaultMode = AUTHENTICATION_MODES[1];
    }
    defaultMode.selected = true;

    return {
      modes: authentication_modes,
      default: defaultMode,
      custom: AUTHENTICATION_MODES[0]
    };
  }

  function getRegionalNameLabel(product_id) {
    if (REGIONAL_NAMES[product_id]) {
      return REGIONAL_NAMES[product_id].label;
    }
    return undefined;
  }

  function isPassportABTestEnabled() {
    var isEnabled;
    isEnabled = false;
    if (
      EG.Users.Constants.ABTests.add_passport == EG.Users.Profile.ABTest.viewA ||
      EG.Users.Constants.ABTests.add_passport == EG.Users.Profile.ABTest.viewB
    ) {
      isEnabled = true;
    }

    return isEnabled;
  }

  function assignPrivacyAndTOCTarget(targetElems) {
    var $privacyPolicy, $toc;

    $privacyPolicy = $(targetElems.privacyPolicy);
    $toc = $(targetElems.toc);

    $privacyPolicy.attr('href', $('#privacy-policy').attr('href'));
    $toc.attr('href', $('#terms-use').attr('href'));
  }

  function isEventFromDifferentSource(evt, elemClass) {
    return evt.target.classList.contains(elemClass);
  }

  function getLoyaltyProgramId(loyaltyProgram) {
    var _loyaltyProgram, loyaltyProgramId, programId, documentType;

    _loyaltyProgram = deepCloneObject(loyaltyProgram);
    programId = _loyaltyProgram.natural_id || _loyaltyProgram.program_natural_id;
    documentType = _loyaltyProgram.type_code || _loyaltyProgram.document_type_code;

    loyaltyProgramId = programId + '-' + _loyaltyProgram.lob.toLowerCase() + '-' + documentType.toLowerCase();

    return loyaltyProgramId;
  }

  function storeRequestedTab(tab) {
    var tabDetails;
    tabDetails = _.find(tabsLoaded, {
      tabName: tab
    });
    if (_.isUndefined(tabDetails)) {
      tabsLoaded.push({
        tabName: tab,
        requireUpdate: false
      });
      return;
    }
    tabDetails.requireUpdate = false;
  }

  function setRoleBasedTabToUpdate() {
    tabsLoaded = tabsLoaded.map(function(tab) {
      if (ROLE_SPECIFIC_TABS.indexOf(tab.tabName) != -1) {
        tab.requireUpdate = true;
      }
      return tab;
    });
  }

  function ifTabRequireUpdate(tabName) {
    var tab;
    tab = _.find(tabsLoaded, {
      tabName: tabName
    });
    if (_.isUndefined(tab)) {
      return true;
    }
    return tab.requireUpdate;
  }

  function isConfigUndefined(templateConfig, configName) {
    if (configName == null || templateConfig == null) {
      return true;
    }
    var configHierarchy = configName.split('.');
    var configValue = templateConfig[configHierarchy[0]];
    for (var count = 1; count < configHierarchy.length; count++) {
      if (configValue == null) {
        return true;
      }
      configValue = configValue[configHierarchy[count]];
    }
    return false;
  }

  function randomString() {
    return (1 + Math.random()).toString(36).substring(2) + moment.now();
  }

  function getEmailRegex() {
    return [
      {
        value: /^(?=[a-zA-Z0-9_][a-zA-Z0-9@._'+-]{5,253}$)[a-zA-Z0-9-._'+]{1,64}@(?:[a-zA-Z0-9-._]{1,63}[\\.]){1,8}[a-zA-Z0-9_]{2,63}$/
      }
    ];
  }

  function getESGuestRoleId(isTabAligned) {
    if(isTabAligned){
      return  [EG.Users.Constants.ROLES.guest , EG.Users.Constants.ROLES.euguest];
    }else{
      return EG.isNA ? [EG.Users.Constants.ROLES.guest] : [EG.Users.Constants.ROLES.euguest];
    }
  }

  function getGlobalGuestRoleID(isTabAligned) {
    if(isTabAligned){
      return ['10001','EU10001'];
    }else{
      return EG.isNA ? ['10001'] : ['EU10001'];
    }
  }

  function canUpdateRole() {
    if (isScopesExist() && EG.scopes.indexOf('user.update.role') != -1) {
      return true;
    }
    return false;
  }

  function getUitkDate(date, options) {
    var dateObject = new Date(date);
    return uitk.i18n.date(dateObject.getFullYear(), dateObject.getMonth() + 1, dateObject.getDate(), options);
  }

  function getUitkTime(date, options) {
    var dateObject = new Date(date);
    return uitk.i18n.time(dateObject.getHours(), dateObject.getMinutes(), options);
  }

  function getFutureDate(noOfDays){
    var upperLimit, lastDate;
    upperLimit = noOfDays || 30;
    return EG.Users.Utils.getUitkDate(new moment().add(upperLimit,'day'), { style: 'iso'});
  }

  function getTomorrowDate() {
     return EG.Users.Utils.getUitkDate(moment().add(1,'days'), {style: 'iso'});
  }

  function getDaysDiffByCurrentDate(fromDate) {
    var toDate, fromDateObj;
    fromDateObj = moment(fromDate, 'YYYY-MM-DD');
    toDate = moment().startOf('day');
    return moment.duration(fromDateObj.diff(toDate)).asDays();
  }

  function isPastDate(date) {
    return getDaysDiffByCurrentDate(date)<0;
  }

  function getFormattedDateNA(date){
    var formattedDateNA;
    if(!_.isUndefined(date)) {
      formattedDateNA = date.format("MM-DD-YYYY");
    }
    return formattedDateNA;
  }

  function getFormattedDate(date){
    var dateString, formattedString;
    if(!_.isUndefined(date)) {
      dateString = date.split("/");
      formattedString = dateString[2] + '-' + dateString[0] + '-' + dateString[1];
    }
    return formattedString
  }

  function getCalendarDate(date){
    var dateString, dateObj;
    if(date){
      dateString = getUitkDate(moment(date, 'YYYY-MM-DD'), {style: 'iso'});
      dateObj = new Date(dateString);
    }
    return dateObj;
  }

  function hasUneditableFields(config){
      for (var key in config) {
        if (config.hasOwnProperty(key)) {
          if(_.isObject(config[key]) && config[key].enabled && config[key].readonly ){
            return true;
          }
        }
      }
    return false;
  }

  function isConfigFieldEnabledAndEditable(config_field) {
    return config_field.enabled && !config_field.readonly;
  }

  function isAnyFieldEditable(config) {
    var isEditable = false;
    for (var key in config) {
      if (config.hasOwnProperty(key) && _.isObject(config[key]) && config[key].enabled) {
        if(config[key].readonly === false || _.isUndefined(config[key].readonly)) {
          isEditable = true;
        }
      }
    }
    return isEditable;
  }

  function getManagedUsersScopes(userId) {
    var defer,url;

    defer = $.Deferred();
    url = '/auth-service/v2/accounts?userId=' + userId + '&includeScopes=true';
    $.ajax({
          type: 'GET',
          url: url,
      })
          .done(function(response) {
              defer.resolve(response);
          })
          .fail(function(response) {
              var errorMsg;

              errorMsg = EG.Users.Constants.KIBANA_ERROR_MESSAGE_FOR_FETCH;

              errorMsg = errorMsg.replace('{Module}', 'Notification Preferences');
              errorMsg = errorMsg.replace('{component}', 'User role');
              errorMsg = errorMsg.replace('{url}', url);
              uitk.logger.error(errorMsg);
              defer.reject({
                  response: response,
                  component: uitk.i18n.msg('user_associations_roles_label'),
              });
          });
      return defer.promise();
    }

  function shouldMaskData(vieweeId) {
    if((EG.scopes.indexOf('user.view.pii')!==-1))
      return false;
    return !isProfileViewedBySelf(vieweeId) || isTravelConsultant();
  }

  function shouldMaskDataOnDocumentType(vieweeId,docTypeId) {
    if (docTypeId == EG.Users.Constants.DOCUMENT_TYPES.PASSPORT) {
      return !(isProfileViewedBySelf(vieweeId) || isTravelConsultant() || EG.Users.Utils.isAdminLogin());
    } else {
      return !isProfileViewedBySelf(vieweeId) || isTravelConsultant();
    }
  }

  function transformGendersInfo(selectedGenderCode, vieweeId) {
    var genders;
    const genderList = EG.Users.Constants.neutral_gender_enabled ? EG.Users.Constants.genders : EG.Users.Constants.user_genders;
    genders = _.clone(genderList);
    genders = genders.map(function (gender) {
      var result;
      result = _.clone(gender);
      result.selected = gender.value == selectedGenderCode && !shouldMaskData(vieweeId);
      result.name = genderMap.get(result.name)? genderMap.get(result.name):uitk.i18n.msg('profile_title_male');
      return result;
    });
     return genders;
  }


  function transformUserGendersInfo(selectedGenderCode, vieweeId) {
    var genders;
    EG.Users.Constants.user_genders
    genders = _.clone(EG.Users.Constants.user_genders);
    genders = genders.map(function(gender) {
      var result;
      result = _.clone(gender);
      result.selected = gender.value == selectedGenderCode && !shouldMaskData(vieweeId);
      result.name = result.name === GENDER_MALE_CONSTANT ?  uitk.i18n.msg('profile_title_male') :  uitk.i18n.msg('profile_title_female');
      return result;
    });
    return genders;
  }

  function canViewCompanySettings() {
    if (isScopesExist() && ((EG.scopes.indexOf('company.view.settings') != -1) || (EG.scopes.indexOf('company.search.view') != -1))) {
      return true;
    }
    return false;
  }

  function isTabClosedInMobile() {
    return uitk.adapt.smallScreen && $('#navigation-cards.side-menu.open').length === 1;
  }

  function isCurrentRoute(route) {
    return window.location.href.indexOf(route) > -1;
  }

  function redirectToRoute(redirectRoute) {
      let route = EG.Users.Constants.ROUTES[redirectRoute];

      if(isCurrentRoute(route.value)) {
        EG.Users.Profile.Globals.scrollToValiditySettings = false;
        if(isTabClosedInMobile()) {
          $(route.tab).trigger('click');
        }
        $(route.scroll)[0].scrollIntoView();
        setTimeout(function () {
          $(route.focus).trigger('focus');
        }, 0);
        return;
      }
      EG.Users.Profile.Globals.scrollToValiditySettings = true;
      $(route.tab).trigger('click');
  }

  function hasScopeToViewMarketingCommLink(managedUserScopes) {
    return (!_.isEmpty(managedUserScopes) && (managedUserScopes.indexOf('user.access.marketingcommunication') !== -1));
  }

	function fetchGGMTemplates(options,templateId) {
		let url = EG.Users.Constants.FETCH_TEMPLATES_URL;
		if (templateId) {
			url = EG.Users.Constants.FECTH_TEMPLATE_BY_ID + '/' + templateId +
				'?company_id=' + (EG.globalContext.get('managedCompanyId') || EG.user.companyId);
		}
		const config = {
			...options,
			headers: {
				'Transaction-Id': EG.Users.Utils.randomString(),
				...EG.commonClientHeaders,
				...options.headers,
			}
		};
		
		return fetch(url, config)
			.then(async response => {
				if (response.ok) {
				return await response.json();
				} else {
				return Promise.reject(response);
				}
			});
    }

  function enhanceSelfRegitrationConfigForGlobalGuest(templateConfig) {
    templateConfig.user_self_registration.personal_info.date_of_birth.enabled = true;
    templateConfig.user_self_registration.personal_info.cc3.enabled = false;
  }

  function isUserActive() {
    return EG.Users.Profile.Data.userInfo.is_active;
  }

  function stringTemplateParser(expression, valueObj) {
    const templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
    let text = expression.replace(templateMatcher, (substring, value, index) => {
      value = valueObj[value];
      return value;
    });
    return text
  }

  function checkIfProfileFlow(url){
    return url.includes("/users/#profile");
  }
  function getHeaders(url){
    if(checkIfProfileFlow(url) && EG.user.companyId>0)
    {
      return {
        'Transaction-Id': EG.Users.Utils.randomString(),
        'Message-Source': 'users',
        'Authorization-Active-CompanyId': EG.user.companyId
      }
    }
    else{
      return {
        'Transaction-Id': EG.Users.Utils.randomString(),
        'Message-Source': 'users'
      }
    }
  }

  function getCompaniesAccordingToRegion(requiredUserIds, region){
    let filteredRequiredUserIds={};
    for(let i in requiredUserIds){
      if(getCompanyRegion(i)===region){
        filteredRequiredUserIds[i]=requiredUserIds[i];
      }
    }
    return filteredRequiredUserIds;
  }

  function getMessagesAsList(messages){

    let msg = '<ul class="self-invite-note">';
    messages.forEach(function (message){
      msg=msg+'<li>' + message + '</li>';
    });
    msg= msg + '</ul>';
    return msg;
  }

  function triggerOmnitureOnFilterCheckboxSelection(filterName, selectedLength, checked){
    let action="Unchecked";
    if(checked){
      action="Checked";
    }

    uitk.analytics.track('a',{
      linkId:'Users.Search.Filters.'+ filterName + '.' + selectedLength + '.' + action,
      linkObj: null,
      linkTrackVars:'prop26'
    });
  }

  function canMigrateLegacyGuest(){
    return isScopesExist() && EG.scopes.indexOf(EG.Users.Profile.Globals.userMigrateLegacyGuest) !== -1;
  }

  function canViewGlobalTravelerGroupUI() {
    return EG.Users.Constants.traveler_group_enabled && isScopesExist() && EG.scopes.indexOf('company.manage.travelergroup') !== -1;
  }

  function setCompanyTravelerGroups() {
    if(!EG.Users.Constants.CompanyTravelerGroup) {
      let travelerGroupCollection = new EG.Users.Profile.Collections.TravelerGroup({}, {
        companyId: EG.Users.Utils.getCompanyId(),
      });
      travelerGroupCollection.comparator = 'name';
      const travelerGroupPromise = travelerGroupCollection.getTravelerGroups();
      $.when(travelerGroupPromise).then(function (companyTravelerGroup) {
        EG.Users.Constants.CompanyTravelerGroup = companyTravelerGroup;
      });
    }
  }

  function setCompanyServiceLevels() {
    if(!EG.Users.Constants.CompanyServiceLevels) {
      let serviceLevelCollection = new EG.Users.Profile.Collections.ServiceLevel({}, {
        companyId: EG.Users.Utils.getCompanyId(),
      });
      let serviceLevelPromise;
      serviceLevelCollection.comparator = 'label';
      EG.Users.Constants.CompanyServiceLevelCollection = serviceLevelCollection;
      if (EG.isNA) {
        serviceLevelPromise = serviceLevelCollection.getServiceLevels();
      }
      $.when(serviceLevelPromise).then(function (companyTServiceLevels) {
        EG.Users.Constants.CompanyServiceLevels = companyTServiceLevels;
      });
    }
  }

  function setComapnyCdfResponsCache(data){
    EG.Users.Constants.companyCdfDetails = EG.Users.Constants.companyCdfDetails || {};
    EG.Users.Constants.companyCdfDetails=data;
  }

  function getComapnyCdfResponsCache(){
    EG.Users.Constants.companyCdfDetails = EG.Users.Constants.companyCdfDetails || {};
   const companyCdfDetails = EG.Users.Constants.companyCdfDetails;
    if (companyCdfDetails) {
        return EG.Users.Utils.deepCloneObject(companyCdfDetails);
    }
    return {}
  }

 /** This function adds validations for Airline Gender
  * @returns the object with validation and error message
  *
  */
  function applyAirlineGenderValidations() {
    var airlineGenderValidations = [];
    airlineGenderValidations.push({
      required: true,
      msg: 'field_validation_required'
    });
    airlineGenderValidations.push({
      min: "1",
      msg: 'field_validation_required'
    });
    return airlineGenderValidations;
  }

  /** This function on the bases of gender selection hides or unhides the airline gender and title support
   * and also adds or removes Mx title
   * @param genderElement html element of gender
   * @param titleElement html element of title
   */
  function handleSelectionOfGender(genderElement,titleElement,personalInfo){
    const selected_gender = genderElement.val();
    const title = titleElement;
    if (selected_gender === EG.Users.Constants.UNSPECIFIED_GENDER_CODE || selected_gender === EG.Users.Constants.UNDISCLOSED_GENDER_CODE) {
      title.append($("<option></option>")
          .attr("value", EG.Users.Constants.NEUTRAL_TITLE_CODE)
          .text(EG.Users.Constants.NEUTRAL_TITLE));
      title.val(EG.Users.Constants.NEUTRAL_TITLE_CODE).change();
      title.prop("disabled", true)
      $('#user_gender_list').removeClass('hidden');
      if(EG.user.productId != EG.Users.Constants.US_PROUDUCT_ID) {
        $('#user_title_list').removeClass('hidden');
      }
      $('#airline_info_header').removeClass('hidden');
      $('#user_title_code').val(DEFAULT_VALUE).change();
      $('#user_gender_code').val(DEFAULT_VALUE).change();
    } else {
      if (title.val() === EG.Users.Constants.NEUTRAL_TITLE_CODE) {
        title.prop("disabled", false)
        title.find(":selected").remove();
        title.val(EG.Users.Constants.MR_TITLE_CODE).change();
      }
        $('#user_gender_list').addClass('hidden');
        if(EG.user.productId != EG.Users.Constants.US_PROUDUCT_ID) {
          $('#user_title_list').addClass('hidden');
        }
        $('#airline_info_header').addClass('hidden');
        $('#user_title_code').val(DEFAULT_VALUE).change();
        $('#user_gender_code').val(DEFAULT_VALUE).change();
    }
    personalInfo.validation["user_gender_code"] = null;
    personalInfo.validation["user_title_code"]=null;
  }

  /** This function populates the GenderNeutralFields in the form for binary gender choice
   *
   * @param personalInfoInputValues Info form with Input Values
   */
  function populateGenderNeutralFields(personalInfoInputValues) {
    if(personalInfoInputValues.attributes.user_gender_code == DEFAULT_VALUE) {
      personalInfoInputValues.attributes.user_gender_code = undefined;
    }
    if(personalInfoInputValues.attributes.user_title_code == DEFAULT_VALUE) {
      personalInfoInputValues.attributes.user_title_code = undefined;
    }
    if(EG.user.productId == EG.Users.Constants.US_PROUDUCT_ID) {
      personalInfoInputValues.attributes.user_title_code = DEFAULT_VALUE;
    }

    if (personalInfoInputValues.attributes.gender_code != EG.Users.Constants.UNSPECIFIED_GENDER_CODE && personalInfoInputValues.attributes.gender_code != EG.Users.Constants.UNDISCLOSED_GENDER_CODE) {
      if (EG.user.productId == EG.Users.Constants.US_PROUDUCT_ID) {
        personalInfoInputValues.attributes.personal_title_code = DEFAULT_VALUE;
      }
      personalInfoInputValues.attributes.user_gender_code = parseInt(personalInfoInputValues.attributes.gender_code);
      personalInfoInputValues.attributes.user_title_code = parseInt(personalInfoInputValues.attributes.personal_title_code);
    }
  }

  /** This function exchanges the values of Binary gender and Title fields with Neutral gender and title
   * This function exchanges the value of current input form before sending it to the api
   * @param personalInfoInputValues Info form with Input Values
   */
  function exchangeGenderNeutralFieldsWithNormalGenderField(personalInfoInputValues) {
    if (personalInfoInputValues.gender_code == EG.Users.Constants.UNSPECIFIED_GENDER_CODE || personalInfoInputValues.gender_code == EG.Users.Constants.UNDISCLOSED_GENDER_CODE) {
      const user_gender_code = personalInfoInputValues.gender_code

      personalInfoInputValues.gender_code = personalInfoInputValues.user_gender_code
      personalInfoInputValues.user_gender_code = parseInt(user_gender_code);

      personalInfoInputValues.personal_title_code = personalInfoInputValues.user_title_code
      personalInfoInputValues.user_title_code = parseInt(EG.Users.Constants.NEUTRAL_TITLE_CODE);
    }
    if(EG.user.productId == EG.Users.Constants.US_PROUDUCT_ID) {
      personalInfoInputValues.personal_title_code = DEFAULT_VALUE
    }
  }


  /** This function exchanges the values of Binary gender and Title fields with Neutral gender and title
   *  This function exchanges the value of previous form values
   * @param personalInfoInputValues Info form with Input Values
   */
  function exchangeGenderNeutralFieldsWithNormalGenderFieldForOldValue(personalInfoInputValues) {
    if (personalInfoInputValues.user_gender_code == EG.Users.Constants.UNSPECIFIED_GENDER_CODE || personalInfoInputValues.user_gender_code == EG.Users.Constants.UNDISCLOSED_GENDER_CODE) {
      const user_gender_code = personalInfoInputValues.gender_code
      const user_title_code = personalInfoInputValues.personal_title_code

      personalInfoInputValues.gender_code = personalInfoInputValues.user_gender_code
      personalInfoInputValues.user_gender_code = user_gender_code;

      personalInfoInputValues.personal_title_code = parseInt(personalInfoInputValues.user_title_code)
      personalInfoInputValues.user_title_code = user_title_code;
    }
  }

  function getDomainBasedOnConfig(key) {
    return EG.Users.Constants.global_user_service_uri_map[key] === true;
  }

  function isScrollDownPastTableHeight(scrollTop, innerHeight, scrollHeight) {
    return scrollTop + innerHeight + SCROLL_OFFSET >= scrollHeight;
  }
  function isRequestedProfileinNA() {
    if(!_.isUndefined(EG.Users.RequestedUser)) {
      return isNAProductId(EG.Users.RequestedUser.productId);
    }
    return EG.isNA;
  }

  /**
   * Let the world know !
   */
  EG.Users.Utils.getActionToStatus = getActionToStatus;
  EG.Users.Utils.getStatusToActions = getStatusToActions;
  EG.Users.Utils.getResponseJSON = getResponseJSON;
  EG.Users.Utils.parseSearchQuery = parseSearchQuery;
  EG.Users.Utils.autoComplete = autoComplete;
  EG.Users.Utils.isFCBEnabledForActionActivation = isFCBEnabledForActionActivation;
  EG.Users.Utils.getPhoneType = getPhoneType;
  EG.Users.Utils.getPhoneTypeCode = getPhoneTypeCode;
  EG.Users.Utils.getI18MonthNames = getI18MonthNames;
  EG.Users.Utils.deepCloneObject = deepCloneObject;
  EG.Users.Utils.getNAPhoneAreacodeNumber = getNAPhoneAreacodeNumber;
  EG.Users.Utils.parseJson = parseJson;
  EG.Users.Utils.recurse = recurse;
  EG.Users.Utils.getCompanyId = getCompanyId;
  EG.Users.Utils.getManagedCompanyIds = getManagedCompanyIds;
  EG.Users.Utils.getSearchCompanyIds = getSearchCompanyIds;
  EG.Users.Utils.isMultiGpidTMSearchEnabled = isMultiGpidTMSearchEnabled;
  EG.Users.Utils.getPOSCountryIso2 = getPOSCountryIso2;
  EG.Users.Utils.getPOSCountryIso3 = getPOSCountryIso3;
  EG.Users.Utils.getUserStatus = getUserStatus;
  EG.Users.Utils.updateUserIdInGlobalContext = updateUserIdInGlobalContext;
  EG.Users.Utils.getSelectedUserProfileId = getSelectedUserProfileId;
  EG.Users.Utils.getEmailsFromCollection = getEmailsFromCollection;
  EG.Users.Utils.getNamesFromCollection = getNamesFromCollection;
  EG.Users.Utils.fetchUserIdFromGlobalcontext = fetchUserIdFromGlobalcontext;
  EG.Users.Utils.userModal = userModal;
  EG.Users.Utils.applyFilterValidation = applyFilterValidation;
  EG.Users.Utils.applySearchValidation = applySearchValidation;
  EG.Users.Utils.parseDefaultFormAttributes = parseDefaultFormAttributes;
  EG.Users.Utils.scrollTop = scrollTop;
  EG.Users.Utils.scrollDown = scrollDown;
  EG.Users.Utils.getPhonePrefix = getPhonePrefix;
  EG.Users.Utils.setDesktopView = setDesktopView;
  EG.Users.Utils.setMobileView = setMobileView;
  EG.Users.Utils.isMobileView = isMobileView;
  EG.Users.Utils.getOffset = getOffset;
  EG.Users.Utils.isTravelConsultant = isTravelConsultant;
  EG.Users.Utils.canManageBDM = canManageBDM;
  EG.Users.Utils.hasManageUserRights = hasManageUserRights;
  EG.Users.Utils.hasManageOrgManagerRights =  hasManageOrgManagerRights
  EG.Users.Utils.hasCommunityTabRights = hasCommunityTabRights;
  EG.Users.Utils.hasManageGuestRights = hasManageGuestRights;
  EG.Users.Utils.allowGuestManager = allowGuestManager;
  EG.Users.Utils.hasManageGuestOnly = hasManageGuestOnly;
  EG.Users.Utils.isGGMViewingSelf = isGGMViewingSelf;
  EG.Users.Utils.canUpdateUserStatus = canUpdateUserStatus;
  EG.Users.Utils.canUpdateGuestStatus = canUpdateGuestStatus;
  EG.Users.Utils.canUpdateStatus = canUpdateStatus;
  EG.Users.Utils.canViewTravelerPicker = canViewTravelerPicker;
  EG.Users.Utils.canViewArrangeePicker = canViewArrangeePicker;
  EG.Users.Utils.canCreateNewUser = canCreateNewUser;
  EG.Users.Utils.canCreateGuestUser = canCreateGuestUser;
  EG.Users.Utils.canDeleteProfileWithPastTrips = canDeleteProfileWithPastTrips;
  EG.Users.Utils.transformCollectionToAutocompleteCompatible = transformCollectionToAutocompleteCompatible;
  EG.Users.Utils.getUrlParam = getUrlParam;
  EG.Users.Utils.redirectToErrorPage = redirectToErrorPage;
  EG.Users.Utils.replaceSpaceWithUnderscore = replaceSpaceWithUnderscore;
  EG.Users.Utils.isProfileViewedBySelf = isProfileViewedBySelf;
  EG.Users.Utils.getGenderByCode = getGenderByCode;
  EG.Users.Utils.getAbsoluteUrl = getAbsoluteUrl;
  EG.Users.Utils.reloadPage = reloadPage;
  EG.Users.Utils.isMultiTravller = isMultiTravller;
  EG.Users.Utils.isAdminLogin = isAdminLogin;
  EG.Users.Utils.analyzeSave = analyzeSave;
  EG.Users.Utils.getMaxCostCentreToView = getMaxCostCentreToView;
  EG.Users.Utils.hideLoadingScreen = hideLoadingScreen;
  EG.Users.Utils.showLoadingScreen = showLoadingScreen;
  EG.Users.Utils.getErrorDescription = getErrorDescription;
  EG.Users.Utils.isGuestUser = isGuestUser;
  EG.Users.Utils.transformNumericToAlphabet = transformNumericToAlphabet;
  EG.Users.Utils.canEditLockedCDF = canEditLockedCDF;
  EG.Users.Utils.removeLoader = removeLoader;
  EG.Users.Utils.isUserGuest = isUserGuest;
  EG.Users.Utils.formatToLocalizedNumber = formatToLocalizedNumber;
  EG.Users.Utils.canAssignClosedTravelerGroup = canAssignClosedTravelerGroup;
  EG.Users.Utils.getParameterByName = getParameterByName;
  EG.Users.Utils.getErrorListContent = getErrorListContent;
  EG.Users.Utils.getAuthenticationModes = getAuthenticationModes;
  EG.Users.Utils.isFlexibleArranger = isFlexibleArranger;
  EG.Users.Utils.isLoggedInUser = isLoggedInUser;
  EG.Users.Utils.isEsiUser = isEsiUser;
  EG.Users.Utils.isLoggedInUserESIPrimary =isLoggedInUserESIPrimary;
  EG.Users.Utils.getRegionalNameLabel = getRegionalNameLabel;
  EG.Users.Utils.isPassportABTestEnabled = isPassportABTestEnabled;
  EG.Users.Utils.scrollTo = scrollTo;
  EG.Users.Utils.assignPrivacyAndTOCTarget = assignPrivacyAndTOCTarget;
  EG.Users.Utils.isEventFromDifferentSource = isEventFromDifferentSource;
  EG.Users.Utils.getLoyaltyProgramId = getLoyaltyProgramId;
  EG.Users.Utils.storeRequestedTab = storeRequestedTab;
  EG.Users.Utils.setRoleBasedTabToUpdate = setRoleBasedTabToUpdate;
  EG.Users.Utils.ifTabRequireUpdate = ifTabRequireUpdate;
  EG.Users.Utils.ifConfigUndefined = isConfigUndefined;
  EG.Users.Utils.randomString = randomString;
  EG.Users.Utils.getCardExpiryStatus = getCardExpiryStatus;
  EG.Users.Utils.getESGuestRoleId = getESGuestRoleId;
  EG.Users.Utils.getEmailRegex = getEmailRegex;
  EG.Users.Utils.canUpdateRole = canUpdateRole;
  EG.Users.Utils.getUitkDate = getUitkDate;
  EG.Users.Utils.getFormattedDateNA = getFormattedDateNA;
  EG.Users.Utils.getUitkTime = getUitkTime;
  EG.Users.Utils.isGGMViewingGGU = isGGMViewingGGU;
  EG.Users.Utils.isGlobalGuestUserType = isGlobalGuestUserType;
  EG.Users.Utils.isLoggedInUserGlobalGuest = isLoggedInUserGlobalGuest;
  EG.Users.Utils.getFutureDate = getFutureDate;
  EG.Users.Utils.getFormattedDate = getFormattedDate;
  EG.Users.Utils.getCalendarDate = getCalendarDate;
  EG.Users.Utils.isGlobalArranger = isGlobalArranger;
  EG.Users.Utils.hasUneditableFields = hasUneditableFields;
  EG.Users.Utils.isConfigFieldEnabledAndEditable = isConfigFieldEnabledAndEditable;
  EG.Users.Utils.shouldMaskData = shouldMaskData;
  EG.Users.Utils.transformGendersInfo = transformGendersInfo;
  EG.Users.Utils.transformUserGendersInfo = transformUserGendersInfo;
  EG.Users.Utils.canEditReservationEmailsForAllTrips = canEditReservationEmailsForAllTrips;
  EG.Users.Utils.getManagedUsersScopes = getManagedUsersScopes;
  EG.Users.Utils.isAnyFieldEditable = isAnyFieldEditable;
  EG.Users.Utils.canViewCompanySettings = canViewCompanySettings;
  EG.Users.Utils.getTomorrowDate = getTomorrowDate;
  EG.Users.Utils.getDaysDiffByCurrentDate = getDaysDiffByCurrentDate;
  EG.Users.Utils.canArrange = canArrange;
  EG.Users.Utils.shouldMaskDataOnDocumentType = shouldMaskDataOnDocumentType;
  EG.Users.Utils.isPastDate = isPastDate;
  EG.Users.Utils.redirectToRoute = redirectToRoute;
  EG.Users.Utils.hasScopeToViewMarketingCommLink = hasScopeToViewMarketingCommLink;
  EG.Users.Utils.canManageGuest = canManageGuest;
  EG.Users.Utils.hasCreateUserRights = hasCreateUserRights;
  EG.Users.Utils.getGlobalGuestRoleID = getGlobalGuestRoleID;
  EG.Users.Utils.hasManageTmWizardRights = hasManageTmWizardRights;
  EG.Users.Utils.fetchGGMTemplates = fetchGGMTemplates;
  EG.Users.Utils.enhanceSelfRegitrationConfigForGlobalGuest = enhanceSelfRegitrationConfigForGlobalGuest;
  EG.Users.Utils.isUserActive = isUserActive;
  EG.Users.Utils.hasManageApprovalSettingRights = hasManageApprovalSettingRights;
  EG.Users.Utils.stringTemplateParser = stringTemplateParser;
  EG.Users.Utils.checkIfProfileFlow = checkIfProfileFlow;
  EG.Users.Utils.getHeaders = getHeaders;
  EG.Users.Utils.getCompanyName = getCompanyName;
  EG.Users.Utils.getManagedCompanyIdsForRegion = getManagedCompanyIdsForRegion;
  EG.Users.Utils.getMultiGpidQueryParams = getMultiGpidQueryParams;
  EG.Users.Utils.getCompanyRegion = getCompanyRegion;
  EG.Users.Utils.getUserIdForGivenCompany = getUserIdForGivenCompany;
  EG.Users.Utils.getCompanyIdsForGivenRegion = getCompanyIdsForGivenRegion;
  EG.Users.Utils.getCompaniesAccordingToRegion= getCompaniesAccordingToRegion;
  EG.Users.Utils.getMessagesAsList= getMessagesAsList;
  EG.Users.Utils.triggerOmnitureOnFilterCheckboxSelection= triggerOmnitureOnFilterCheckboxSelection;
  EG.Users.Utils.canMigrateLegacyGuest = canMigrateLegacyGuest;
  EG.Users.Utils.canViewGlobalTravelerGroupUI = canViewGlobalTravelerGroupUI;
  EG.Users.Utils.setCompanyTravelerGroups = setCompanyTravelerGroups;
  EG.Users.Utils.setCompanyServiceLevels = setCompanyServiceLevels;
  EG.Users.Utils.setComapnyCdfResponsCache = setComapnyCdfResponsCache;
  EG.Users.Utils.getComapnyCdfResponsCache = getComapnyCdfResponsCache;
  EG.Users.Utils.applyAirlineGenderValidations=applyAirlineGenderValidations;
  EG.Users.Utils.handleSelectionOfGender=handleSelectionOfGender;
  EG.Users.Utils.populateGenderNeutralFields=populateGenderNeutralFields;
  EG.Users.Utils.exchangeGenderNeutralFieldsWithNormalGenderField=exchangeGenderNeutralFieldsWithNormalGenderField;
  EG.Users.Utils.exchangeGenderNeutralFieldsWithNormalGenderFieldForOldValue=exchangeGenderNeutralFieldsWithNormalGenderFieldForOldValue;
  EG.Users.Utils.getDomainBasedOnConfig=getDomainBasedOnConfig;
  EG.Users.Utils.isScrollDownPastTableHeight = isScrollDownPastTableHeight;
  EG.Users.Utils.isRequestedProfileinNA = isRequestedProfileinNA;
})(EG);
